// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__fr5ME","chart-loader":"Chart_chart-loader__ofC+u"};